import gql from 'graphql-tag';
import {
  ENRICHMENT_CLASS_SCHEDULE_FRAGMENT,
  ENRICHMENT_CLASS_INFO_FRAGMENT,
} from './commonFragments';

export const GET_CHILD_INVOICE_FOR_MONTH = gql`
  query getChildInvoiceForMonth(
    $childID: Int!
    $enrichmentID: Int!
    $forMonth: Datetime!
  ) {
    getChildInvoiceForMonth(
      IDChild: $childID
      IDEnrichment: $enrichmentID
      forMonth: $forMonth
    ) {
      status
      invoiceDate
      invoiceNo
    }
  }
`;

export const REGISTER_WAITLIST_PROGRAM_SUBSCRIBE = gql`
  mutation subscribeEnrichmentProgram(
    $childID: Int!
    $enrichmentClassID: Int!
    $effectiveFrom: Datetime!
  ) {
    subscribeEnrichmentClassChild(
      IDChild: $childID
      IDEnrichmentClass: $enrichmentClassID
      effectiveFrom: $effectiveFrom
    ) {
      ID
    }
  }
`;

export const GET_CLASS_SCHEDULED_BY_START_DATE_AND_END_DATE = gql`
  query classOcurrenceByMonth(
    $enrichmentClassID: Int!
    $startDate: Datetime
    $endDate: Datetime
  ) {
    getEnrichmentClassOccurrencesByClassIdWithRange(
      IDEnrichmentClass: $enrichmentClassID
      startDate: $startDate
      endDate: $endDate
    ) {
      totalCount
      data {
        ID
        to
        date
        from
        status
        displayStatus
        parentEnrichmentClassOccurrence {
          date
        }
        childEnrichmentClassOccurrence {
          date
        }
      }
    }
  }
`;

export const CANCEL_WAILIST_SUBSCRIPTION = gql`
  mutation cancelSubscription($enrichmentClassIDByChild: Int!) {
    cancelSubscription(enrichmentClassChildId: $enrichmentClassIDByChild)
  }
`;

export const GET_ENRICHMENT_ATTACHMENTS = gql`
  query(
    $programmeID: Int!
    $attachmentCategory: String!
    $filter: EnrichmentAttachmentFilter
    $pagination: Pagination
  ) {
    getEnrichmentAttachments(
      IDEnrichment: $programmeID
      attachmentCategory: $attachmentCategory
      filter: $filter
      pagination: $pagination
    ) {
      data {
        ID
        fileURL
        fileKey
        fileSize
        fileName
        type
      }
    }
  }
`;

export const GET_ENRICHMENT_CLASS_DETAIL = gql`
  query getClassDetail($classID: Int!) {
    enrichmentClassByID(id: $classID) {
      ID
      name
      status
      displayStatus
      currentSessionsActive
      upcomingSessionsActive
      createdAt
      updatedAt
      remark
      maxClassSize
      effectiveMaxClassSize
      autoEnrollStatus {
        status
        lastUpdateAt
      }
      centre {
        ID
        label
      }
      currentSchedule {
        ID
        day
        startTime
        endTime
        effectiveFrom
        effectiveTo
        fkEnrichmentClass
      }
      enrichmentClassOccurrences {
        data {
          date
          status
        }
      }
      futureSchedules {
        data {
          ID
          day
          startTime
          endTime
          effectiveFrom
          effectiveTo
          fkEnrichmentClass
        }
      }
      enrichmentClassChildren(filter: { status: "enrolled" }) {
        totalCount
        data {
          child {
            childLevels {
              data {
                fkLevel
              }
            }
          }
        }
      }
      enrichmentClassSchedules {
        data {
          ID
          effectiveFrom
          effectiveTo
        }
      }
      enrichment {
        ID
        fkEnrichmentSubsidy
        title
        minClassSize
        maxClassSize
        type
        enrollType
        sessionPerMonth
        enrichmentLevels {
          data {
            level {
              ID
              label
            }
          }
        }
        enrichmentPrices {
          data {
            amount
            effectiveFrom
            effectiveTo
          }
        }
        currentPrice {
          ID
          amount
          effectiveFrom
          effectiveTo
          enrichmentSubsidyPrices {
            data {
              ID
              amount
              fkEnrichmentSubsidyTier
            }
          }
        }
        futurePrices {
          data {
            ID
            amount
            effectiveFrom
            effectiveTo
          }
        }
        enrichmentLevelPrices {
          data {
            ID
            fkLevel
            amount
            effectiveFrom
            effectiveTo
          }
        }
        sessionDuration
        enrichmentLevelConfigs {
          data {
            fkLevel
            displayName
            sessionDuration
            minClassSize
          }
        }
      }
      totalChildren
      enrichmentClassLevels {
        data {
          level {
            ID
            label
          }
        }
      }
      effectiveRange {
        from
        to
      }
    }
  }
`;

export const GET_ENRICHMENT_PROGRAMMES = gql`
  query getAllEnrichmentProgram(
    $centreID: Int
    $filter: EnrichmentFilter
    $pagination: Pagination
    $statuses: [String!]
  ) {
    getAllEnrichmentProgram(
      centreID: $centreID
      filter: $filter
      pagination: $pagination
      statuses: $statuses
    ) {
      totalCount
      data {
        ID
        title
        type
        active
        status
        sessionDuration
        sessionPerMonth
        displayStatus
        vendor {
          ID
          name
          enrichmentVendorDocumentsApprovers {
            data {
              fkVendor
              isApprover
            }
          }
        }
        effectiveRange {
          from
          to
        }
        enrichmentPrices {
          data {
            amount
            effectiveFrom
            effectiveTo
            active
          }
        }
        currentPrice {
          ID
          amount
        }
        enrichmentLevels {
          data {
            level {
              ID
              label
            }
          }
        }
        enrollType
        enrichmentLevelConfigs {
          data {
            fkLevel
            displayName
            sessionDuration
          }
        }
      }
    }
  }
`;

export const GET_VENDOR_ENRICHMENT_PROGRAMMES = gql`
  query getAllEnrichmentProgram(
    $centreID: Int
    $filter: EnrichmentFilter
    $pagination: Pagination
    $statuses: [String!]
  ) {
    getAllEnrichmentProgram(
      centreID: $centreID
      filter: $filter
      pagination: $pagination
      statuses: $statuses
    ) {
      totalCount
      data {
        ID
        title
        type
        active
        status
        sessionDuration
        displayStatus
        enrollType
        effectiveRange {
          from
          to
        }
        enrichmentPrices {
          data {
            effectiveFrom
            effectiveTo
          }
        }
      }
    }
  }
`;

export const GET_ENRICHMENT_CLASS_LIST = gql`
  query getAllEnrichmentClass(
    $centreIds: [Int!]
    $actions: [String!]
    $missingAttendanceOnly: Boolean
    $nextCalendarDate: Datetime
    $vendorDecisions: [String!]
    $enrichmentIds: [Int!]
    $statuses: [String!]
    $unverifiedMonths: [Int!]
    $searchTerm: String
    $filter: EnrichmentClassFilter
    $pagination: Pagination
    $year: Int
  ) {
    getAllEnrichmentClass(
      centreIds: $centreIds
      unverifiedMonths: $unverifiedMonths
      actions: $actions
      missingAttendanceOnly: $missingAttendanceOnly
      nextCalendarDate: $nextCalendarDate
      enrichmentIds: $enrichmentIds
      vendorDecisions: $vendorDecisions
      statuses: $statuses
      q: $searchTerm
      filter: $filter
      pagination: $pagination
      year: $year
    ) {
      totalCount
      data {
        ID
        fkEnrichment
        name
        autoEnrollStatus {
          status
          lastUpdateAt
        }
        enrichmentClassAttendances {
          totalCount
        }
        enrichmentClassLevels {
          data {
            fkLevel
            level {
              label
            }
          }
        }
        enrichmentClassOccurrences {
          data {
            displayStatus
            status
          }
        }
        currentSchedule {
          effectiveFrom
          effectiveTo
          day
          startTime
          endTime
        }
        enrichmentClassSchedules(filter: { active: [0, 1] }) {
          data {
            day
            startTime
            endTime
            effectiveFrom
            effectiveTo
          }
        }
        futureSchedules {
          data {
            day
            startTime
            endTime
            effectiveFrom
            effectiveTo
          }
        }
        pastSchedules {
          data {
            day
            startTime
            endTime
            effectiveFrom
            effectiveTo
          }
        }
        enrichment {
          enrollType
          title
          minClassSize
          maxClassSize
          enrichmentLevelConfigs {
            data {
              fkLevel
              displayName
            }
          }
        }
        centre {
          ID
          label
        }
        status
        displayStatus
        sessionsOnHoliday
        currentActiveEnrolments
        upcomingActiveEnrolments
        currentSessionsActive
        upcomingSessionsActive
        waitlistCount
        waitlistCountInUpcomingMonth
        totalChildrenNextMonth
        vendorDecision {
          key
          value
        }
        enrichmentClassLevels {
          data {
            level {
              label
            }
          }
        }
      }
    }
  }
`;

export const GET_ENRICHMENT_CLASS_VENDOR_LIST = gql`
  query getAllEnrichmentClassVendor(
    $centreIds: [Int!]
    $nextCalendarDate: Datetime
    $vendorDecision: String
    $enrichmentIds: [Int!]
    $missingAttendanceMonths: [Int!]
    $statuses: [String!]
    $isOngoing: Boolean
    $filter: EnrichmentClassFilter
    $year: Int
    $pagination: Pagination
  ) {
    getAllEnrichmentClassVendor(
      centreIds: $centreIds
      isOngoing: $isOngoing
      nextCalendarDate: $nextCalendarDate
      enrichmentIds: $enrichmentIds
      statuses: $statuses
      vendorDecision: $vendorDecision
      missingAttendanceMonths: $missingAttendanceMonths
      filter: $filter
      year: $year
      pagination: $pagination
    ) {
      totalCount
      data {
        ID
        fkEnrichment
        name
        enrichmentClassAttendances {
          totalCount
        }
        enrichmentClassLevels {
          data {
            level {
              label
            }
          }
        }
        enrichmentClassOccurrences {
          data {
            displayStatus
            status
          }
        }
        currentSchedule {
          effectiveFrom
          effectiveTo
          day
          startTime
          endTime
        }
        enrichmentClassSchedules(filter: { active: [0, 1] }) {
          data {
            day
            startTime
            endTime
            effectiveFrom
            effectiveTo
          }
        }
        futureSchedules {
          data {
            day
            startTime
            endTime
            effectiveFrom
            effectiveTo
          }
        }
        pastSchedules {
          data {
            day
            startTime
            endTime
            effectiveFrom
            effectiveTo
          }
        }
        enrichment {
          title
          minClassSize
          maxClassSize
        }
        centre {
          ID
          label
        }
        status
        displayStatus
        sessionsOnHoliday
        currentActiveEnrolments
        upcomingActiveEnrolments
        currentSessionsActive
        upcomingSessionsActive
        waitlistCount
        totalChildrenNextMonth
        maxClassSize
        vendorDecision {
          key
          value
        }
        enrichmentClassLevels {
          data {
            level {
              label
            }
          }
        }
      }
    }
  }
`;

export const GET_ENRICHMENT_REASSIGN_CLASS_LIST = gql`
  query getReassignClassListForClassChild(
    $enrichmentClassChildID: Int!
    $effectiveDate: Datetime!
    $filter: EnrichmentClassFilter
  ) {
    getReassignClassListForClassChild(
      IDEnrichmentClassChild: $enrichmentClassChildID
      effectiveDate: $effectiveDate
      filter: $filter
    ) {
      totalCount
      data {
        ID
        name
        status
        remainingSlots(at: $effectiveDate)
      }
    }
  }
`;

export const GET_ENRICHMENT_ENROLMENT_COUNT = gql`
  query getEnrolmentChildCount(
    $filterForWithdrawalCount: EnrichmentClassChildFilter
  ) {
    withdrawnChildrenCount: getAllEnrichmentClassChild(
      filter: $filterForWithdrawalCount
    ) {
      totalCount
    }
  }
`;

export const GET_ENROLMENT_CHILD_COUNT_BY_YEAR = gql`
  query getEnrolmentChildCountByYear(
    $year: Int!
    $filter: EnrichmentClassChildFilter
  ) {
    getEnrolmentChildCountByYear(year: $year, filter: $filter) {
      month
      totalCount
    }
  }
`;

export const GET_ENRICHMENT_CLASS_ENROLMENT_LIST = gql`
  query getAllEnrichmentClassChild(
    $period: Datetime
    $nextMonthPeriod: Datetime
    $withdrawalStatus: [String!]
    $refundStatus: [String!]
    $searchTerm: String
    $filter: EnrichmentClassChildFilter
    $pagination: Pagination
  ) {
    getAllEnrichmentClassChild(
      period: $period
      q: $searchTerm
      refundStatuses: $refundStatus
      withdrawalStatuses: $withdrawalStatus
      filter: $filter
      pagination: $pagination
    ) {
      totalCount
      data {
        ID
        fkChild
        fkEnrichmentClass
        effectiveFrom
        effectiveTo
        status
        remark
        active
        createdAt
        refundStatus
        withdrawalStatus
        isNotRegisteredChild
        paymentStatus(forMonth: $period)
        nextMonthPaymentStatus: paymentStatus(forMonth: $nextMonthPeriod)
        updatedAt
        currentLevel {
          centre {
            label
          }
          level {
            label
          }
        }
        currentClass {
          class {
            label
          }
        }
        enrichmentWithdrawal {
          ID
          initiatedDate
          parentInitiated
          userByCreatedBy {
            ID
            firstname
            lastname
          }
          userByApprovedBy {
            firstname
            lastname
          }

          userByCancelledBy {
            firstname
            lastname
            isParent
          }
          effectiveDate
          approved
          rejected
          cancelled
          rejectReason
        }
        adhocRefundType(forMonth: $period)
        isMakeRefundLastMonth
        refundInfo {
          UnUtilizedAmount
          NextMonthFee
          Initiator {
            firstname
            lastname
          }
          Approver {
            ID
            firstname
            lastname
          }
        }
        enrichmentClass {
          name
          displayStatus
          fkEnrichment
          currentSessionsActive
          upcomingSessionsActive
          maxClassSize
          enrichment {
            title
            ID
          }
        }
        child {
          ID
          firstname
          lastname
          currentLevel {
            level {
              label
            }
          }
          currentClass {
            class {
              label
            }
          }
          enrichmentClassChildren {
            data {
              fkChild
              effectiveFrom
              enrichmentClass {
                name
                fkEnrichment
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_ENRICHMENT_CLASS_FK_ENRICHMENT = gql`
  query getEnrichmentClassFkEnrichment($classID: Int!) {
    enrichmentClassByID(id: $classID) {
      ID
      fkEnrichment
      autoEnrollStatus {
        status
        lastUpdateAt
      }
    }
  }
`;

export const GET_NEXT_LEVEL_ASSIGNMENT_CHILDREN = gql`
  query GetNextLevelAssignmentChildren(
    $filter: GetNextLevelAssignmentChildrenDTO!
    $pagination: Pagination
    $fkEnrichment: Int!
  ) {
    getNextLevelAssignmentChildren(filter: $filter, pagination: $pagination) {
      totalCount
      effectiveAssignedDate
      data {
        status
        finishedAt
        nextLevel {
          ID
          label
        }
        child {
          ID
          fullname
          currentLevel {
            ID
            fkLevel
            level {
              label
            }
          }
          upcomingLevel {
            ID
            fkLevel
          }
          enrolmentStatus {
            status
            label
          }
          currentEnrichmentClass(fkEnrichment: $fkEnrichment) {
            totalCount
            data {
              ID
              status
              effectiveFrom
              effectiveTo
              enrichmentClass {
                ID
                name
              }
            }
          }
          upcomingEnrichmentClass(fkEnrichment: $fkEnrichment) {
            totalCount
            data {
              ID
              status
              effectiveFrom
              effectiveTo
              enrichmentClass {
                ID
                name
              }
            }
          }
        }
        availableNextYearClasses {
          ID
          name
          status
          maxClassSize
          effectiveMaxClassSize
          currentActiveEnrolments
          currentFee
          subsidisedFee
        }
      }
    }
  }
`;

export const GET_CLASSES_REMAINING_SLOTS = gql`
  query GetClassesRemainingSlots($classIDs: [Int!]!, $at: Datetime!) {
    getEnrichmentClasses(filter: { ID: [{ eq: $classIDs }] }) {
      data {
        ID
        remainingSlots(at: $at)
      }
    }
  }
`;

export const SUBMIT_NEXT_LEVEL_ASSIGNMENTS = gql`
  mutation SubmitNextLevelAssignments(
    $input: SubmitNextLevelAssignmentsInput!
  ) {
    submitNextLevelAssignments(input: $input) {
      success
      total
      batch {
        ID
        fkSchool
        fkUser
        academicYear
        totalChildren
        createdAt
        updatedAt
      }
      failedItems {
        fkChild
        fkNextClassId
        errorMessage
      }
    }
  }
`;

export const GET_CHILD_ENRICHMENT_CLASS_CHILDREN = gql`
  query getChildEnrichmentClassChildren($IDChild: Int!) {
    childByID(IDChild: $IDChild) {
      enrichmentClassChildren {
        totalCount
        data {
          ID
          status
          effectiveFrom
          effectiveTo
          enrichmentClass {
            ID
            name
            enrichment {
              ID
              title
            }
          }
        }
      }
    }
  }
`;

export const GET_ALL_AVAILABLE_CHILDREN_FOR_ENRICHMENT_CLASS = gql`
  query getAllAvailableChildForEnrichmentClass(
    $classID: Int!
    $searchTerm: String
    $effectiveFrom: Datetime!
  ) {
    getAllAvailableChildForEnrichmentClass(
      classID: $classID
      q: $searchTerm
      effectiveFrom: $effectiveFrom
    ) {
      totalCount
      data {
        ID
        firstname
        lastname
        childLevelAt(time: $effectiveFrom) {
          level {
            label
          }
        }
      }
    }
  }
`;

export const SAVE_ENRICHMENT_CLASS = gql`
  mutation saveEnrichmentClass($dto: EnrichmentClassCreateUpdateDTO!) {
    createOrSaveEnrichmentClass(dto: $dto) {
      ID
      name
      enrichment {
        ID
        title
      }
      centre {
        ID
        label
      }
    }
  }
`;

export const SAVE_ENRICHMENT_TRAINER = gql`
  mutation createEnrichmentTrainerUser(
    $name: String!
    $email: String!
    $phoneNumberCountryCode: String
    $phoneNumber: String
    $centreIds: [Int!]!
    $documents: [VendorTrainerDocumentDto!]!
  ) {
    createEnrichmentTrainerUser(
      name: $name
      email: $email
      phoneNumberCountryCode: $phoneNumberCountryCode
      phoneNumber: $phoneNumber
      centreIds: $centreIds
      documents: $documents
    ) {
      ID
    }
  }
`;

export const WITHDRAW_CHILD_FROM_EP_CLASS = gql`
  mutation withdrawEnrichmentClassChild(
    $childID: Int!
    $initiatedDate: Datetime!
    $withdrawDate: Datetime!
    $reason: String!
    $refund: Boolean!
  ) {
    withdrawEnrichmentClassChild(
      IDEnrichmentClassChild: $childID
      initiatedDate: $initiatedDate
      effectiveDate: $withdrawDate
      remark: $reason
      refund: $refund
    )
  }
`;

export const REASSIGN_CHILD_FROM_EP_CLASS = gql`
  mutation reassignEnrichmentClassChild(
    $enrichmentClassChildID: Int!
    $toIDClass: Int!
    $effectiveDate: Datetime!
    $notifyParent: Boolean!
  ) {
    reassignEnrichmentClassChild(
      IDEnrichmentClassChild: $enrichmentClassChildID
      toIDClass: $toIDClass
      effectiveDate: $effectiveDate
      notifyParent: $notifyParent
    )
  }
`;

export const REGISTER_CHILD_IN_EP_CLASS = gql`
  mutation registerWaitlistedClassChild($enrichmentClassChildID: Int!) {
    registerWaitlistedClassChild(
      IDEnrichmentClassChild: $enrichmentClassChildID
    ) {
      ID
    }
  }
`;

export const SAVE_ENRICHMENT_CLASS_SCHEDULES = gql`
  mutation createOrSaveEnrichmentClassSchedules(
    $IDEnrichmentClass: Int!
    $dtoList: [EnrichmentClassScheduleCreateUpdateDTO!]!
  ) {
    createOrSaveEnrichmentClassSchedules(
      IDEnrichmentClass: $IDEnrichmentClass
      dtoList: $dtoList
    ) {
      totalCount
      data {
        ID
        fkEnrichmentClass
        day
        startTime
        endTime
        effectiveFrom
        effectiveTo
        active
        createdAt
        updatedAt
      }
    }
  }
`;

export const CANCEL_ENRICHMENT_CLASS = gql`
  mutation cancelClass(
    $classID: Int!
    $effectiveDate: Datetime!
    $remark: String!
    $notifyParent: Boolean!
  ) {
    cancelEnrichmentClass(
      IDEnrichmentClass: $classID
      cancelDate: $effectiveDate
      remark: $remark
      notifyParent: $notifyParent
    )
  }
`;

export const DELETE_ENRICHMENT_CLASS = gql`
  mutation deleteClass($classID: Int!) {
    removeEnrichmentClassByID(ID: $classID)
  }
`;

export const DELETE_ENRICHMENT_CLASS_SCHEDULE = gql`
  mutation deleteEnrichmentClassScheduleById(
    $IDEnrichmentClass: Int!
    $IDEnrichmentClassSchedule: Int!
  ) {
    deleteEnrichmentClassScheduleById(
      IDEnrichmentClass: $IDEnrichmentClass
      IDEnrichmentClassSchedule: $IDEnrichmentClassSchedule
    )
  }
`;

export const ADD_CHILD_TO_ENRICHMENT_CLASS = gql`
  mutation enrolEnrichmentClassChild(
    $classID: Int!
    $childID: Int!
    $effectiveFrom: Datetime!
  ) {
    enrolEnrichmentClassChild(
      IDEnrichmentClass: $classID
      IDChild: $childID
      effectiveFrom: $effectiveFrom
    ) {
      ID
      fkChild
      fkEnrichmentClass
      effectiveFrom
      effectiveTo
      status
    }
  }
`;

export const DOWNLOAD_ATTENDANCE_LIST = gql`
  query exportAttendanceList($classID: Int!, $period: Datetime!) {
    exportAttendanceList(IDEnrichmentClass: $classID, period: $period)
  }
`;

export const GET_ENRICHMENT_ATTENDANCE_CLASS_SUMMARY = gql`
  query getEnrichmentClassSummary(
    $classID: Int!
    $sessionStatuses: [String!]
    $attendanceStatuses: [String!]
    $year: Int
    $pagination: Pagination
  ) {
    getEnrichmentClassSummary(
      IDClass: $classID
      sessionStatuses: $sessionStatuses
      year: $year
      pagination: $pagination
      attendanceStatuses: $attendanceStatuses
    ) {
      totalCount
      data {
        initialMarkedUser {
          firstname
          lastname
        }
        enrichmentClassOccurrence {
          ID
          fkEnrichmentClass
          fkEnrichmentClassOccurrence
          date
          status
          displayStatus
          enrichmentClassOccurrence {
            date
          }
          isVendorInvoiceCreated
          enrichmentClass {
            name
            currentSessionsActive
            upcomingSessionsActive
            displayStatus
            centre {
              label
            }
            enrichment {
              title
            }
            currentSchedule {
              effectiveFrom
              effectiveTo
            }
            futureSchedules {
              data {
                effectiveFrom
                effectiveTo
              }
            }
          }
        }
      }
    }
  }
`;

export const SAVE_PROGRAMME = gql`
  mutation saveEnrichmentDraft($dto: EnrichmentDraftItemCreateDTO!) {
    saveEnrichmentDraft(dto: $dto) {
      ID
      fkDraft
      fkEnrichment
      fkEnrichmentSubsidy
      fkVendor
      fkSchool
      type
      title
      cover
      accPacCode
      description
      gst
      cda
      sessionDuration
      sessionPerWeek
      sessionPerMonth
      minClassSize
      maxClassSize
      active
      createdAt
      updatedAt
    }
  }
`;

export const PUBLISH_PROGRAM = gql`
  mutation publishEnrichmentDraft($dto: EnrichmentDraftItemCreateDTO!) {
    publishEnrichmentDraft(dto: $dto) {
      ID
      title
    }
  }
`;

export const UPDATE_EXISTING_EP_PROGRAMME = gql`
  mutation updatePublishedEnrichmentProgramme($dto: EnrichmentCreateDTO!) {
    updatePublishedEnrichmentProgramme(dto: $dto) {
      ID
    }
  }
`;

export const UPDATE_PROGRAM = gql`
  mutation saveEnrichment($dto: EnrichmentCreateDTO!) {
    saveEnrichment(dto: $dto) {
      ID
    }
  }
`;

export const GET_ADHOC_REFUND_INFO = gql`
  query getSessionRefundInformation(
    $IDEnrichmentClass: Int!
    $IDChild: Int!
    $month: Datetime!
  ) {
    getSessionRefundInformation(
      IDEnrichmentClass: $IDEnrichmentClass
      IDChild: $IDChild
      month: $month
    ) {
      date
      status
    }
  }
`;

export const COVER_PHOTO_UPLOAD = gql`
  mutation getEnrichmentCoverPhotoUploadUrl($vendorID: Int!, $file: Upload!) {
    getEnrichmentCoverPhotoUploadUrl(IDVendor: $vendorID, file: $file) {
      Url
      Key
      Filename
    }
  }
`;

export const DOCUMENT_ATTACHMENT_UPLOAD = gql`
  mutation getEnrichmentAttachmentUploadURL($vendorID: Int!, $file: Upload!) {
    getEnrichmentAttachmentUploadURL(IDVendor: $vendorID, file: $file) {
      Url
      Key
      Filename
    }
  }
`;

export const GET_ALL_ENRICHMENT_VENDOR_ADMINS = gql`
  query getAllEnrichmentVendorAdmins(
    $vendorID: Int!
    $filter: EnrichmentVendorAdminFilter
    $pagination: Pagination
  ) {
    getAllEnrichmentVendorAdmins(
      vendorID: $vendorID
      filter: $filter
      pagination: $pagination
    ) {
      totalCount
      data {
        ID
        firstname
        lastname
        email
        userAccessControls {
          data {
            ID
            fkSchool
          }
        }
        addresses {
          data {
            name
            address
            building
            floor
            unit
            city
            country
            postcode
            name
            mobilePhone
            user {
              ID
              firstname
              lastname
              mobilePhone
              mobilePhoneCountryCode
            }
          }
        }
        enrichmentVendorAdminsByFkUser {
          data {
            ID
            vendor {
              name
              phone
              phoneCountryCode
              website
              gstNumber
              uenNumber
              code

              enrichmentVendorDocumentsApprovers {
                data {
                  ID
                  fkVendor
                  isApprover
                }
              }

              vendorBankAccounts {
                data {
                  accountName
                  accountNumber
                  bankBicCode {
                    ID
                    bankCode
                    bankName
                    bicCode
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_ALL_ENRICHMENT_VENDOR = gql`
  query getAllEnrichmentVendor(
    $pagination: Pagination
    $q: String
    $filter: VendorFilter
  ) {
    getAllEnrichmentVendor(q: $q, filter: $filter, pagination: $pagination) {
      totalCount
      data {
        ID
        fkSchool
        fkUser
        name
        uenNumber
        gstNumber
        phone
        phoneCountryCode
        website
        gstNumber
        uenNumber
        code
        updatedAt
        createdAt
        user {
          ID
          firstname
          lastname
          email
          homePhone
          homePhoneCountryCode
          mobilePhoneCountryCode
          mobilePhone

          addresses {
            data {
              address
              name
              building
              floor
              unit
              city
              country
              postcode
              name
              mobilePhone
            }
          }
        }
        vendorBankAccounts {
          data {
            accountName
            accountNumber
            bankBicCode {
              ID
              bankCode
              bankName
              bicCode
            }
          }
        }
        enrichmentVendorAdmins {
          data {
            userByFkUser {
              email
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_ENRICHMENT_ADMIN_USER = gql`
  mutation updateEnrichmentAdminUser(
    $dto: EnrichmentAdminCreateDTO!
    $vendorId: Int!
    $userId: Int!
  ) {
    updateEnrichmentAdminUser(dto: $dto, vendorId: $vendorId, userId: $userId) {
      ID
      firstname
      lastname
      email
    }
  }
`;

export const GET_ALL_ENRICHMENT_DRAFT = gql`
  query getAllDraftEnrichmentProgram(
    $vendorId: Int
    $filter: EnrichmentDraftFilter
    $pagination: Pagination
  ) {
    getAllDraftEnrichmentProgram(
      vendorID: $vendorId
      filter: $filter
      pagination: $pagination
    ) {
      totalCount
      data {
        ID
        label
        status
        userByFkUser {
          ID
          firstname
          lastname
        }
        enrichmentDraftItems {
          data {
            fkEnrichment
            createdAt
            updatedAt
            title
            type
            active
            sessionDuration
            enrollType
            vendor {
              name
            }
            enrichment {
              ID
            }
          }
        }
      }
    }
  }
`;

export const GET_ENRICHMENT_PROGRAM_LIST = gql`
  query getEnrichmentClassesForChild(
    $childID: Int!
    $centreID: Int!
    $status: String
    $dataAt: Datetime!
    $enrichmentType: EnrichmentType
    $month: Datetime
    $filter: EnrichmentClassFilter
    $subsidyFilter: MorphedEnrichmentSubsidyFilter
    $pagination: Pagination
  ) {
    getEnrichmentClassesForChild(
      IDChild: $childID
      IDCentre: $centreID
      status: $status
      at: $dataAt
      enrichmentType: $enrichmentType
      month: $month
      filter: $filter
      subsidyFilter: $subsidyFilter
      pagination: $pagination
    ) {
      totalCount
      data {
        ID
        name
        fkEnrichment
        # fkEnrichmentSubsidy (need this for YGT)
        currentFee
        subsidisedFee
        displayStatus
        availableFrom
        childRegistrationStatus
        waitlistCount
        currentSchedule {
          ...EnrichmentClassScheduleFragment
        }
        remainingSlots
        childRegistrationStatus
        enrichment {
          ID
          cover
          title
          coverURL
          type
          enrollType
          currentPrice {
            amount
          }
          gst
          enrichmentLevelConfigs {
            data {
              fkLevel
              displayName
              sessionDuration
              minClassSize
            }
          }
        }
        futureSchedules {
          data {
            ...EnrichmentClassScheduleFragment
          }
        }
      }
    }
  }
  ${ENRICHMENT_CLASS_SCHEDULE_FRAGMENT}
`;

export const GET_ENRICHMENT_PROGRAM_DETAIL = gql`
  query getEnrichmentProgramDetail($id: Int!, $filter: EnrichmentFilter) {
    enrichmentByID(id: $id, filter: $filter) {
      ID
      fkVendor
      fkEnrichmentSubsidy
      createdAt
      updatedAt
      title
      type
      displayStatus
      cover
      coverURL
      description
      gst
      cda
      sessionDuration
      sessionPerWeek
      sessionPerMonth
      minClassSize
      maxClassSize
      status
      accPacCode
      costCentre
      gst
      cda
      remark
      notify
      enrollType
      effectiveRange {
        from
        to
      }
      currentCost {
        ID
        effectiveFrom
        effectiveTo
        amount
        enrichmentSubsidyCosts {
          data {
            ID
            fkEnrichmentSubsidyTier
            amount
          }
        }
      }
      enrichmentCosts {
        data {
          fkEnrichment
        }
      }
      futureCosts {
        data {
          effectiveFrom
          effectiveTo
          amount
          ID
        }
      }
      futurePrices {
        data {
          effectiveFrom
          effectiveTo
          amount
          ID
        }
      }
      pastCosts {
        data {
          effectiveFrom
          effectiveTo
          amount
          ID
        }
      }
      pastPrices {
        data {
          effectiveFrom
          effectiveTo
          amount
          ID
        }
      }
      currentPrice {
        ID
        effectiveFrom
        effectiveTo
        amount
        fkEnrichment
        enrichmentSubsidyPrices {
          data {
            ID
            fkEnrichmentSubsidyTier
            amount
          }
        }
      }

      enrichmentLevels {
        data {
          level {
            ID
            label
          }
        }
      }
      enrichmentClasses {
        totalCount
        data {
          enrichmentClassLevels {
            data {
              level {
                ID
                label
              }
            }
          }
        }
      }
      enrichmentAttachments {
        data {
          ID
          type
          fileName
          fileURL
          fileKey
          fkEnrichment
          fileSize
          mime
        }
      }
      enrichmentCentres {
        data {
          centre {
            ID
            label
          }
        }
      }
      enrichmentLevelConfigs {
        data {
          ID
          fkEnrichment
          fkLevel
          displayName
          sessionDuration
          minClassSize
          maxClassSize
          description
        }
      }
      enrichmentLevelCosts {
        data {
          ID
          fkLevel
          amount
          effectiveFrom
          effectiveTo
        }
      }
      enrichmentLevelPrices {
        data {
          ID
          fkLevel
          amount
          effectiveFrom
          effectiveTo
        }
      }
    }
  }
`;

export const GET_ENRICHMENT_PROGRAMME_DRAFT_BY_ID = gql`
  query enrichmentDraftByID($draftID: Int!, $filter: EnrichmentDraftFilter) {
    enrichmentDraftByID(id: $draftID, filter: $filter) {
      ID
      enrichmentDraftItems {
        data {
          ID
          fkVendor
          title
          cover
          coverURL
          description
          type
          gst
          cda
          sessionDuration
          sessionPerWeek
          sessionPerMonth
          minClassSize
          maxClassSize
          accPacCode
          costCentre
          gst
          cda
          documents
          media
          notify
          cost {
            ID
            amount
            effectiveFrom
            effectiveTo
          }
          price {
            ID
            amount
            effectiveFrom
            effectiveTo
          }
          levels {
            data {
              ID
              label
            }
          }
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const REMOVE_ENRICHMENT_BY_ID = gql`
  mutation removeEnrichmentByID($id: Int!) {
    removeEnrichmentByID(ID: $id)
  }
`;

export const DEACTIVATE_ENRICHMENT = gql`
  mutation deactivateEnrichment(
    $IDEnrichment: Int!
    $effectiveDate: Datetime!
    $remark: String!
  ) {
    deactivateEnrichment(
      IDEnrichment: $IDEnrichment
      effectiveDate: $effectiveDate
      remark: $remark
    )
  }
`;

export const SAVE_ENRICHMENT_COST = gql`
  mutation saveEnrichmentCostPrice(
    $programmeID: Int!
    $costList: [EnrichmentPriceCostCreateDTO!]!
  ) {
    saveEnrichmentCost(IDEnrichment: $programmeID, costs: $costList) {
      data {
        ID
        effectiveFrom
        effectiveTo
      }
    }
  }
`;

export const SAVE_ENRICHMENT_PRICE = gql`
  mutation saveEnrichmentPrice(
    $programmeID: Int!
    $priceList: [EnrichmentPriceCostCreateDTO!]!
  ) {
    saveEnrichmentPrice(IDEnrichment: $programmeID, prices: $priceList) {
      data {
        ID
        effectiveFrom
        effectiveTo
      }
    }
  }
`;

export const GET_ALL_ENRICHMENT_CLASS_SESSION = gql`
  query getAllEnrichmentClassSession(
    $enrichmentClassID: Int!
    $isClosure: Boolean
    $statuses: [String!]
    $months: [Datetime!]
    $filter: EnrichmentClassOccurrenceFilter
    $pagination: Pagination
  ) {
    getAllEnrichmentClassSession(
      enrichmentClassID: $enrichmentClassID
      isClosure: $isClosure
      statuses: $statuses
      months: $months
      filter: $filter
      pagination: $pagination
    ) {
      totalCount
      data {
        ID
        isCentreClosure
        fkEnrichmentClass
        fkEnrichmentClassOccurrence
        enrichmentClassOccurrence {
          date
          from
          to
          remarks
          updatedAt
          user {
            firstname
            lastname
          }
        }
        status
        from
        to
        remarks
        accessLink
        accessLinkDescription
        cancelAffectedChildren
        refundFee
        displayStatus
        date
        createdAt
        updatedAt
        user {
          firstname
          lastname
        }
        enrichmentClass {
          name
          centre {
            label
          }
          enrichment {
            title
            type
          }
        }
      }
    }
  }
`;

export const REMOVE_CARD_FROM_CHILD = gql`
  mutation removeCard($cardId: Int!) {
    removeCard(IDCard: $cardId)
  }
`;

export const GET_ALL_SAVED_CARDS = gql`
  query getAllSavedCardDetails {
    getCards {
      cardId
      tokenId
      status
      isDefault
      card {
        brand
        expiry
        fundingMethod
        number
        scheme
      }
      addedBy {
        firstname
        lastname
      }
      pgwStatus
      updated_at
      used_at
    }
  }
`;

export const GET_ALL_ASSIGNED_CARDS = gql`
  query getAllAssignedCards {
    assignedCards {
      card {
        tokenId
        cardId
        status
        isDefault
        card {
          brand
          expiry
          fundingMethod
          number
          scheme
        }
        pgwStatus
        updated_at
        used_at
      }
      child {
        ID
        firstname
        lastname
        imageKey
      }
    }
  }
`;

export const SUBMIT_CARD_SESSION_DATA = gql`
  mutation submitCardDetails($sessionID: String!, $isDefault: Boolean) {
    tokenizePaymentCard(sessionId: $sessionID, isDefault: $isDefault)
  }
`;

export const SET_DEFAULT_CARD = gql`
  mutation setCardAsDefault($cardId: Int!) {
    setCardAsDefault(cardId: $cardId)
  }
`;

export const ASSIGN_CARD_TO_CHILD = gql`
  mutation assignCardToChild(
    $childID: Int!
    $cardID: Int!
    $status: EnrichmentPaymentCardRelationStatus!
  ) {
    assignCardToChild(childId: $childID, cardId: $cardID, status: $status)
  }
`;

export const GET_ATTENDANCE_BY_SESSION = gql`
  query getAttendanceBySession(
    $enrichmentClassID: Int!
    $enrichmentClassOccurrenceID: Int!
  ) {
    getAttendanceBySession(
      IDEnrichmentClass: $enrichmentClassID
      IDEnrichmentClassOccurrence: $enrichmentClassOccurrenceID
    ) {
      enrichmentClass {
        ID
        name
        enrichment {
          fkVendor
        }
        centre {
          ID
        }
        enrichmentClassChildren {
          data {
            ID
            paymentStatus
          }
        }
      }
      enrichmentClassOccurrence {
        ID
        displayStatus
        updatedAt
      }
      initialMarkedUser {
        firstname
        lastname
      }
      children {
        child {
          firstname
          lastname
          ID
        }
        attendanceId
        enrichmentClassChildId
        status
        invoiceNo
        paidOn
        paymentStatus
      }
    }
  }
`;

export const GET_ENRICHMENT_CHILD_INVOICES = gql`
  query getEnrichmentChildInvoiceList(
    $enrichmentID: [Int!]
    $enrichmentClassID: [Int!]
    $from: Datetime
    $to: Datetime
    $ftsInput: String
    $pagination: Pagination
    $filter: EnrichmentChildInvoiceFilter
    $status: EnrichmentChildInvoiceQueryStatus
  ) {
    getEnrichmentChildInvoiceList(
      IDEnrichment: $enrichmentID
      IDEnrichmentClass: $enrichmentClassID
      from: $from
      to: $to
      ftsInput: $ftsInput
      pagination: $pagination
      status: $status
      filter: $filter
    ) {
      totalCount
      data {
        ID
        fkChild
        invoiceNo
        label
        invoiceDate
        invoiceDateYearMonth
        grandTotal
        pdfURLKey
        preSignedUrl
        status
        queryStatus
        updatedAt
        voidBy
        voidRemark
        child {
          firstname
          lastname
          birthCertificate
        }
        enrichment {
          title
        }
        centre {
          label
        }
        enrichmentClass {
          name
        }
        debtWriteoff {
          ID
          requestor
          approver
          reason
          createdAt
          enrichmentDebtWriteoffDocuments {
            totalCount
            data {
              ID
              fileKey
              filename
              fileUrl
            }
          }
        }
        createdAt
      }
    }
  }
`;

export const GET_STATIC_CODE = gql`
  query codesByLabelFkSchool(
    $label: String!
    $fkSchool: Int!
    $filter: CodeFilter
    $pagination: Pagination
  ) {
    codesByLabelFkSchool(
      label: $label
      fkSchool: $fkSchool
      filter: $filter
      pagination: $pagination
    ) {
      data {
        ID
        label
        description
      }
    }
  }
`;

export const GET_ENRICHMENT_VENDOR_INVOICES = gql`
  query getEnrichmentVendorInvoiceList(
    $vendorIDs: [Int!]
    $centreIDs: [Int!]
    $from: Datetime
    $to: Datetime
    $searchString: String
    $pagination: Pagination
  ) {
    getEnrichmentVendorInvoiceList(
      vendorIDs: $vendorIDs
      centreIDs: $centreIDs
      from: $from
      to: $to
      searchString: $searchString
      pagination: $pagination
    ) {
      totalCount
      data {
        ID
        fkVendor
        vendor {
          ID
          name
          code
        }
        fkSchool
        fkCentre
        centre {
          ID
          label
        }
        invoiceNo
        label
        totalTaxAmount
        totalAmount
        grandTotal
        pdfURLKey
        preSignedUrl
        status
        invoiceDate
        invoiceDateYearMonth
        createdAt
      }
    }
  }
`;

export const GET_CLASS_OCCURRENCE_LIST = gql`
  query enrichmentClassOccurrencesByFkEnrichmentClass(
    $enrichmentClassID: Int!
    $filter: EnrichmentClassOccurrenceFilter
  ) {
    enrichmentClassOccurrencesByFkEnrichmentClass(
      IDEnrichmentClass: $enrichmentClassID
      filter: $filter
    ) {
      totalCount
      data {
        ID
        date
        enrichmentClass {
          enrichment {
            fkVendor
          }
          centre {
            ID
          }
        }
      }
    }
  }
`;

export const SUBMIT_ATTENDANCE_BY_SESSION = gql`
  mutation submitAttendanceBySession(
    $enrichmentClassID: Int!
    $enrichmentClassOccurrenceID: Int!
    $attendanceList: [EnrichmentAttendanceDto!]!
  ) {
    submitAttendanceBySession(
      IDEnrichmentClass: $enrichmentClassID
      IDEnrichmentClassOccurrence: $enrichmentClassOccurrenceID
      attendanceList: $attendanceList
    )
  }
`;

export const VERIFY_ATTENDANCE_BY_SESSION = gql`
  mutation verifyAttendanceBySession(
    $enrichmentClassID: Int!
    $enrichmentClassOccurrenceID: Int!
    $attendanceList: [EnrichmentAttendanceDto!]!
  ) {
    verifyAttendanceBySession(
      IDEnrichmentClass: $enrichmentClassID
      IDEnrichmentClassOccurrence: $enrichmentClassOccurrenceID
      attendanceList: $attendanceList
    )
  }
`;

export const DELETE_PROGRAMME_DRAFT_BY_ID = gql`
  mutation removeEnrichmentDraftByID($draftID: Int!) {
    removeEnrichmentDraftByID(ID: $draftID)
  }
`;

export const VOID_ADHOC_REFUND = gql`
  mutation voidAdhocRefund($refundID: Int!, $remark: String!) {
    voidAdhocRefund(refundID: $refundID, remark: $remark)
  }
`;

export const RESCHEDULE_ENRICHMENT_CLASS_SESSION = gql`
  mutation rescheduleEnrichmentClassSession(
    $IDEnrichmentClass: Int!
    $dto: RescheduleEnrichmentClassSessionDto!
    $notifyParent: Boolean!
  ) {
    rescheduleEnrichmentClassSession(
      IDEnrichmentClass: $IDEnrichmentClass
      dto: $dto
      notifyParent: $notifyParent
    ) {
      ID
    }
  }
`;

export const CANCEL_ENRICHMENT_CLASS_SESSION = gql`
  mutation cancelEnrichmentClassSessions(
    $IDEnrichmentClass: Int!
    $IDEnrichmentClassOccurrences: [Int!]!
    $remarks: String!
    $notifyParent: Boolean!
  ) {
    cancelEnrichmentClassSessions(
      IDEnrichmentClass: $IDEnrichmentClass
      IDEnrichmentClassOccurrences: $IDEnrichmentClassOccurrences
      remarks: $remarks
      notifyParent: $notifyParent
    )
  }
`;

export const DOWNLOAD_ATTENDANCE_LIST_FOR_MONTH = gql`
  query exportAttendanceList($classID: Int!, $from: Datetime!, $to: Datetime!) {
    exportAttendanceList(IDEnrichmentClass: $classID, from: $from, to: $to)
  }
`;

export const GET_APPROVER_LIST = gql`
  query getEnrichmentApprovers($filter: UserFilter) {
    getEnrichmentApprovers(filter: $filter) {
      ID
      firstname
      lastname
    }
  }
`;

export const GET_REASONS_FOR_ADHOC_DEDUCTIONS = gql`
  query getAdhocRefundDeductionReasons {
    getAdhocRefundDeductionReasons {
      data {
        ID
        label
        description
      }
    }
  }
`;

export const CONTINUE_ENRICHMENT_CLASS_BY_VENDOR = gql`
  mutation continueEnrichmentClassByVendor(
    $classIDs: [Int!]!
    $forMonth: Datetime!
  ) {
    continueEnrichmentClassByVendor(
      enrichmentClassIDs: $classIDs
      forMonth: $forMonth
    )
  }
`;

export const SAVE_ACCESS_LINK = gql`
  mutation addOrEditOccurrenceAccessLink(
    $IDEnrichmentClassOccurrence: Int!
    $IDEnrichmentClass: Int!
    $accessLink: String!
    $accessLinkDescription: String!
  ) {
    addOrEditOccurrenceAccessLink(
      IDEnrichmentClassOccurrence: $IDEnrichmentClassOccurrence
      IDEnrichmentClass: $IDEnrichmentClass
      accessLink: $accessLink
      accessLinkDescription: $accessLinkDescription
    ) {
      accessLink
    }
  }
`;

export const INITIATE_ADHOC_REFUND = gql`
  mutation initiateAdhocRefundForChild(
    $IDClass: Int!
    $IDChild: Int!
    $IDOccurrenceList: [Int!]!
    $IDOccurrenceForRegularRefund: [EnrichmentRegularRefundWithAdhoc!]!
    $IDApprover: Int!
    $reason: String!
  ) {
    initiateAdhocRefundForChild(
      IDClass: $IDClass
      IDChild: $IDChild
      IDOccurrenceList: $IDOccurrenceList
      IDOccurrenceForRegularRefund: $IDOccurrenceForRegularRefund
      IDApprover: $IDApprover
      reason: $reason
    )
  }
`;

export const UPLOAD_CHILD_DOCUMENT = gql`
  mutation createEnrichmentClassChildDocument(
    $dto: EnrichmentClassChildDocumentCreateDTO!
  ) {
    createEnrichmentClassChildDocument(dto: $dto) {
      ID
    }
  }
`;

export const GET_REFUND_OCCURRENCE_LIST = gql`
  query getAllEnrichmentOccurrenceRefund(
    $IDEnrichmentClass: Int!
    $IDChild: Int!
    $month: Datetime!
  ) {
    getAllEnrichmentOccurrenceRefund(
      IDEnrichmentClass: $IDEnrichmentClass
      IDChild: $IDChild
      month: $month
    ) {
      EnrichmentClassOccurrence {
        ID
        date
        enrichmentRefundItems {
          data {
            ID
            fkEnrichmentRefund
            blockReason
            enrichmentRefund {
              voidVendorWithAdhoc
              fkChild
            }
          }
        }
      }
      paymentStatus
    }
  }
`;

export const TOTAL_REFUND_FEE_FOR_CANCEL_SESSIONS = gql`
  query getTotalRefundFeeForCancellingSessions(
    $enrichmentID: Int!
    $classOccurrenceIDs: [Int!]!
  ) {
    getTotalRefundFeeForCancellingSessions(
      IDEnrichmentClass: $enrichmentID
      IDEnrichmentClassOccurrences: $classOccurrenceIDs
    )
  }
`;

export const ENRICHMENT_CLASS_WAITLIST_MANAGEMENT = gql`
  query GetAllEnrichmentClassWaitlistManagement(
    $centreIds: [Int!]
    $enrichmentIds: [Int!]
    $forDate: Datetime
    $filter: EnrichmentClassFilter
    $pagination: Pagination
  ) {
    GetAllEnrichmentClassWaitlistManagement(
      centreIds: $centreIds
      enrichmentIds: $enrichmentIds
      forDate: $forDate
      filter: $filter
      pagination: $pagination
    ) {
      totalCount
    }
  }
`;

export const GET_ENRICHMENT_CHILD_REFUND_LIST = gql`
  query getEnrichmentChildRefundList(
    $IDEnrichment: [Int!]
    $IDEnrichmentClass: [Int!]
    $status: String
    $from: Datetime
    $to: Datetime
    $ftsInput: String
    $filter: EnrichmentRefundFilter
    $pagination: Pagination
  ) {
    getEnrichmentChildRefundList(
      IDEnrichment: $IDEnrichment
      IDEnrichmentClass: $IDEnrichmentClass
      status: $status
      from: $from
      to: $to
      ftsInput: $ftsInput
      filter: $filter
      pagination: $pagination
    ) {
      totalCount
      data {
        ID
        refundNo
        effectiveDate
        refundDate
        createdAt
        status
        totalAmount
        pdfURLKey
        preSignedUrl
        giroExcludedReason
        type
        child {
          firstname
          lastname
          birthCertificate
        }
        enrichment {
          title
        }
        enrichmentClass {
          name
          centre {
            label
          }
        }
        enrichmentManualRefund {
          paymentMode
          payNowNo
          bankAccountNo
          paymentNo
          manualRefundReason
          paymentDate
        }
        enrichmentRefundMeta {
          initiatedBy {
            ID
            firstname
            lastname
          }
          approvedBy {
            ID
            firstname
            lastname
          }
          refundReason
        }
        cancelledBy
        cancelledRemark
        updatedAt
      }
    }
  }
`;

export const GET_MY_ENRICHMENT_REFUND_LIST = gql`
  query GetMyEnrichmentRefundList(
    $IDChild: Int!
    $IDEnrichment: [Int!]
    $IDEnrichmentClass: [Int!]
    $status: String
    $from: Datetime
    $to: Datetime
    $filter: EnrichmentRefundFilter
    $pagination: Pagination
  ) {
    getMyEnrichmentRefundList(
      IDChild: $IDChild
      IDEnrichment: $IDEnrichment
      IDEnrichmentClass: $IDEnrichmentClass
      status: $status
      from: $from
      to: $to
      filter: $filter
      pagination: $pagination
    ) {
      totalCount
      data {
        ID
        fkChild
        fkEnrichmentClass
        fkEnrichment
        fkCentre
        refundNo
        totalAmount
        status
        refundDate
        refundNo
        refundDate
        refundMode
        enrichment {
          title
        }
        enrichmentChildInvoice {
          ID
          invoiceNo
          totalAmount
          status
        }
        enrichmentRefundMeta {
          refundReason
          initiatedBy {
            ID
            firstname
            lastname
          }
          approvedBy {
            ID
            firstname
            lastname
          }
        }
        enrichmentRefundItems {
          data {
            ID
            amount
            enrichmentChildInvoiceItem {
              label
              taxRate
              taxAmount
            }
          }
        }
      }
    }
  }
`;

export const INITIATE_MANUAL_REFUND = gql`
  mutation enrichmentRefundManually(
    $idRefund: Int!
    $paymentMode: EnrichmentManualRefundPaymentMode!
    $paymentNo: String!
    $paymentDate: Datetime!
    $payNowNo: String
    $bankAccountNo: String
  ) {
    enrichmentRefundManually(
      idRefund: $idRefund
      paymentMode: $paymentMode
      paymentNo: $paymentNo
      paymentDate: $paymentDate
      payNowNo: $payNowNo
      bankAccountNo: $bankAccountNo
    ) {
      active
    }
  }
`;

export const CHILD_CLASSES_OCCURRENCE_DETAILS = gql`
  query getClassOccurrencesDetailForChild(
    $IDEnrichmentClass: Int!
    $IDChild: Int!
  ) {
    getClassOccurrencesDetailForChild(
      IDEnrichmentClass: $IDEnrichmentClass
      IDChild: $IDChild
    ) {
      currentMonth {
        month
        occurrences {
          IDOccurrence
          dayOccurrence
          dateOccurrence
          timeFrom
          timeTo
          occurrenceStatus
          paymentStatus
          dateRescheduleTo
          dateRescheduleFrom
        }
      }
      upcomingMonths {
        month
        occurrences {
          IDOccurrence
          dayOccurrence
          dateOccurrence
          timeFrom
          timeTo
          occurrenceStatus
          paymentStatus
          dateRescheduleTo
          dateRescheduleFrom
        }
      }
      pastMonths {
        month
        occurrences {
          IDOccurrence
          dayOccurrence
          dateOccurrence
          timeFrom
          timeTo
          occurrenceStatus
          paymentStatus
          dateRescheduleTo
          dateRescheduleFrom
        }
      }
    }
  }
`;

export const CHECK_VENDOR_CREATED_FOR_OCCURRENCE = gql`
  query checkVendorInvoiceCreatedForOccurrence(
    $IDVendor: Int!
    $IDCentre: Int!
    $IDOccurrence: Int!
  ) {
    CheckVendorInvoiceCreatedForOccurrence(
      IDVendor: $IDVendor
      IDCentre: $IDCentre
      IDOccurrence: $IDOccurrence
    )
  }
`;

export const GET_ALL_CENTRES_WITH_EXISTNG_VENDOR = gql`
  query getAllCentreWithExistingClassVendor(
    $filter: CentreFilter
    $pagination: Pagination
  ) {
    getAllCentreWithExistingClassVendor(
      filter: $filter
      pagination: $pagination
    ) {
      totalCount
      data {
        ID
        label
        fkSchool
      }
    }
  }
`;

export const GET_CARD_TRANSACTION = gql`
  query getPaymentTransactionsByUser {
    getPaymentTransactionsByUser {
      cardId
      orderId
      errMsg
      errCode
      status
      createdAt
      updatedAt
    }
  }
`;

export const GET_VENDOR_PAYABLE_LIST = gql`
  query getEnrichmentVendorPaymentList(
    $filter: EnrichmentVendorPaymentFilter
    $pagination: Pagination
  ) {
    getEnrichmentVendorPaymentList(filter: $filter, pagination: $pagination) {
      totalCount
      data {
        ID
        status
        paymentDate
        importedAt
        giroExportFileURLKey
        preSignedUrlGiroExportFile
        updatedAt
        exportedAt
      }
    }
  }
`;

export const GET_VENDOR_PAYABLE_GIRO_UPLOAD_URL = gql`
  mutation getEnrichmentVendorPaymentGiroUploadURL(
    $month: Datetime!
    $file: Upload!
  ) {
    getEnrichmentVendorPaymentGiroUploadURL(forMonth: $month, file: $file) {
      Url
      Key
    }
  }
`;

export const UPLOAD_VENDOR_PAYABLE_GIRO_FILE = gql`
  mutation uploadVendorPaymentGiroFile($vendorPaymentID: Int!, $url: String!) {
    uploadVendorPaymentGiroFile(IDVendorPayment: $vendorPaymentID, url: $url) {
      ID
    }
  }
`;

export const GET_TOTAL_REFUND_FOR_WITHDRAWN_CHILD = gql`
  query getTotalRefundFeeForWithdrawnChild(
    $IDEnrichmentClassChild: Int!
    $includeFee: Boolean!
    $includeUntilised: Boolean!
    $effectiveFrom: Datetime!
  ) {
    getTotalRefundFeeForWithdrawnChild(
      IDEnrichmentClassChild: $IDEnrichmentClassChild
      includeFee: $includeFee
      includeUntilised: $includeUntilised
      effectiveFrom: $effectiveFrom
    )
  }
`;

export const CHECK_ENRICHMENT_OCCURRENCE_REFUND_ACCOUNT = gql`
  query CheckEnrichmentOccurrenceRefundAccount(
    $IDEnrichmentClass: Int!
    $IDChild: Int!
    $month: Datetime!
  ) {
    checkEnrichmentOccurrenceRefundAccount(
      IDEnrichmentClass: $IDEnrichmentClass
      IDChild: $IDChild
      month: $month
    ) {
      isMismatch
      reason
    }
  }
`;

export const INSTANT_ENRICHMENT_FEE_DEDUCTION_FOR_CHILD = gql`
  mutation instantEnrichmentFeeDeductionForChild(
    $IDChild: Int!
    $IDEnrichmentClass: Int!
    $forMonth: Datetime!
  ) {
    instantEnrichmentFeeDeductionForChild(
      childId: $IDChild
      enrichmentClassId: $IDEnrichmentClass
      forMonth: $forMonth
    ) {
      pdfURLKey
      preSignedUrl
    }
  }
`;

export const ENRICHMENT_CLASSES_BY_CHILD_ID = gql`
  query getEnrichmentClassesByChildID(
    $childID: Int!
    $classChildStatus: EnrichmentClassesChildStatus
    $classStatus: EnrichmentClassesByChildStatus
    $pagination: Pagination
  ) {
    getEnrichmentClassesByChildID(
      childID: $childID
      classChildStatus: $classChildStatus
      classStatus: $classStatus
      pagination: $pagination
    ) {
      totalCount
      data {
        id
        className
        programName
        programID
        programType
        cover
        coverURL
        registerSince
        inActiveSince
        classStatus
        reassignedClass
        reassignedDate
        classEffectiveTo
        idClassChild
        withdrawalStatus
        withdrawalDisabled
        enrichmentClass {
          ID
          enrichment {
            ID
            enrollType
            enrichmentLevelConfigs {
              data {
                fkLevel
                displayName
              }
            }
          }
        }
        upComingSession {
          date
          from
          to
          accessLink
          fkEnrichmentClassOccurrence
        }
      }
    }
  }
`;

export const ENRICHMENT_WITHDRAWAL_CLASSES_FOR_CHILD = gql`
  query getEnrichmentWithdrawalClassesForChild(
    $childID: Int!
    $status: EnrichmentClassChildWithdrawalStatus
    $pagination: Pagination
  ) {
    getEnrichmentWithdrawalClassesForChild(
      childID: $childID
      status: $status
      pagination: $pagination
    ) {
      totalCount
      data {
        id
        programName
        programID
        programType
        cover
        className
        initiatedDate
        lastDayInClass
        withdrawalStatus
        enrichmentClassChildStatus
        withdrawalID
        newClassName
        reassignedTo
      }
    }
  }
`;

export const CANCEL_WITHDRAWAL_REQUEST = gql`
  mutation cancelEnrichmentClassChildWithdrawalByParent(
    $IDWithdrawal: Int!
    $IDChild: Int!
  ) {
    cancelEnrichmentClassChildWithdrawalByParent(
      IDWithdrawal: $IDWithdrawal
      IDChild: $IDChild
    )
  }
`;

export const REGISTER_CHILD_FOR_CURRENT_MONTH = gql`
  mutation registerChildForCurrentMonth($IDClassChild: Int!) {
    registerChildForCurrentMonth(IDClassChild: $IDClassChild)
  }
`;

export const WITHDRAWAL_REQUEST_REFUND_APPROVAL = gql`
  mutation enrichmentApproveRejectWithdrawRequest(
    $withdrawalID: Int!
    $isApproved: Boolean!
    $reason: String
  ) {
    enrichmentApproveRejectWithdrawRequest(
      withdrawalID: $withdrawalID
      isApproved: $isApproved
      reason: $reason
    )
  }
`;

export const GET_PARENT_CLASS_DETAIL = gql`
  query getEnrichmentClassByIDAndChildID(
    $classID: Int!
    $childID: Int!
    $classOccurrenceMonthFilter: FilterOnField
    $enrichmentChildFilterID: FilterOnField
  ) {
    getEnrichmentClassByIDAndChildID(classID: $classID, childID: $childID) {
      ...EnrichmentClassInfoFragment
      enrichmentClassLevels(filter: { active: [0, 1] }) {
        data {
          ID
          fkLevel
          fkEnrichmentClass
          level {
            ID
            label
          }
        }
      }
      enrichmentClassChildren(filter: { fkChild: $enrichmentChildFilterID }) {
        data {
          ID
          fkChild
        }
      }
      enrichmentClassOccurrences(
        filter: { date: $classOccurrenceMonthFilter }
      ) {
        totalCount
        data {
          fkEnrichmentClassOccurrence
          date
          status
          displayStatus
          remarks
          from
          to
        }
      }
      futurePriceForClass {
        programmeFee
        price {
          effectiveFrom
        }
      }
      enrichmentClassSchedules {
        totalCount
        data {
          ...EnrichmentClassScheduleFragment
        }
      }
      currentSchedule {
        ...EnrichmentClassScheduleFragment
      }
      futureSchedules {
        data {
          ...EnrichmentClassScheduleFragment
        }
      }
    }
  }
  ${ENRICHMENT_CLASS_INFO_FRAGMENT}
  ${ENRICHMENT_CLASS_SCHEDULE_FRAGMENT}
`;

export const GET_CLASS_INFO = gql`
  query getEnrichmentClassesForChild(
    $childID: Int!
    $centreID: Int!
    $at: Datetime!
    $status: String
    $filter: EnrichmentClassFilter
    $pagination: Pagination
    $classOccurrenceMonthFilter: FilterOnField
    $enrichmentChildFilterID: FilterOnField
    $enrichmentType: EnrichmentType
  ) {
    getEnrichmentClassesForChild(
      IDChild: $childID
      IDCentre: $centreID
      at: $at
      status: $status
      filter: $filter
      pagination: $pagination
      enrichmentType: $enrichmentType
    ) {
      totalCount
      data {
        ...EnrichmentClassInfoFragment
        maxClassSize
        availableFrom
        waitlistCount
        enrichmentClassLevels {
          data {
            ID
            fkLevel
            fkEnrichmentClass
            level {
              ID
              label
            }
          }
        }
        enrichmentClassChildren(filter: { fkChild: $enrichmentChildFilterID }) {
          data {
            ID
            fkChild
          }
        }
        enrichmentClassOccurrences(
          filter: { date: $classOccurrenceMonthFilter }
        ) {
          totalCount
          data {
            fkEnrichmentClassOccurrence
            date
            status
            displayStatus
            remarks
            from
            to
          }
        }
        enrichmentClassSchedules {
          totalCount
          data {
            ...EnrichmentClassScheduleFragment
          }
        }
        currentSchedule {
          ...EnrichmentClassScheduleFragment
        }
        futureSchedules {
          data {
            ...EnrichmentClassScheduleFragment
          }
        }
        futurePriceForClass {
          programmeFee
          price {
            effectiveFrom
          }
        }
        remainingSlots
        vendorDecision {
          key
          value
        }
      }
    }
  }
  ${ENRICHMENT_CLASS_INFO_FRAGMENT}
  ${ENRICHMENT_CLASS_SCHEDULE_FRAGMENT}
`;

export const CANCEL_ENRICHMENT_WITHDRAWAL_CLASS_CHILD = gql`
  mutation cancelEnrichmentClassChildWithdrawal($IDWithdrawal: Int!) {
    cancelEnrichmentClassChildWithdrawal(IDWithdrawal: $IDWithdrawal)
  }
`;

export const ENRICHMENT_DELETE_ACCESS_LINK = gql`
  mutation deleteOccurrenceAccessLink(
    $IDEnrichmentClass: Int!
    $IDEnrichmentClassOccurrence: Int!
  ) {
    deleteOccurrenceAccessLink(
      IDEnrichmentClassOccurrence: $IDEnrichmentClassOccurrence
      IDEnrichmentClass: $IDEnrichmentClass
    ) {
      ID
    }
  }
`;

export const UNVERIFY_ATTENDANCE_SESSION = gql`
  mutation unverifiedAttendanceSession($IDEnrichmentClassOccurrence: Int!) {
    unverifiedAttendanceSession(
      IDEnrichmentClassOccurrence: $IDEnrichmentClassOccurrence
    )
  }
`;

export const PARENT_WITHDRAWAL_ENRICHMENT_CLASS_CHILD = gql`
  mutation parentWithdrawEnrichmentClassChild(
    $IDChild: Int!
    $IDEnrichmentClassChild: Int!
    $effectiveDate: Datetime!
    $remark: String!
  ) {
    parentWithdrawEnrichmentClassChild(
      IDChild: $IDChild
      IDEnrichmentClassChild: $IDEnrichmentClassChild
      effectiveDate: $effectiveDate
      remark: $remark
    )
  }
`;

export const VERIFY_CENTRE_DESELECTION_ON_EDIT_PROGRAM = gql`
  query verifyCentreRemovalOnProgramEdit(
    $IDEnrichment: Int!
    $centreList: [Int!]!
  ) {
    verifyCentreRemovalOnProgramEdit(
      IDEnrichment: $IDEnrichment
      centreList: $centreList
    )
  }
`;

export const DELETE_ENRICHMENT_VENDOR = gql`
  mutation removeVendorByID($ID: Int!) {
    removeVendorByID(ID: $ID)
  }
`;

export const ENRICHMENT_DISCOUNT = gql`
  fragment enrichmentDiscount on EnrichmentDiscount {
    ID
    on
    type
    value
    from
    to
    active
    createdAt
    updatedAt
  }
`;

export const CREATE_ENRICHMENT_DISCOUNT = gql`
  ${ENRICHMENT_DISCOUNT}
  mutation CREATE_ENRICHMENT_DISCOUNT(
    $dto: EnrichmentDiscountCreateUpdateDTO!
  ) {
    createEnrichmentDiscount(dto: $dto) {
      ...enrichmentDiscount
    }
  }
`;

export const DELETE_ENRICHMENT_DISCOUNT = gql`
  mutation DELETE_DISCOUNT($IDEnrichmentDiscount: Int!) {
    deleteEnrichmentDiscountById(IDEnrichmentDiscount: $IDEnrichmentDiscount)
  }
`;

export const GET_ENRICHMENT_DISCOUNT_BY_CLASS = gql`
  ${ENRICHMENT_DISCOUNT}
  query GET_ENRICHMENT_DISCOUNT_BY_CLASS($ClassIDs: [Int!]!) {
    getEnrichmentDiscountByClass(ClassIDs: $ClassIDs) {
      totalCount
      data {
        ...enrichmentDiscount
        enrichmentDiscountClasses {
          data {
            enrichmentClass {
              ID
              name
            }
          }
        }
      }
    }
  }
`;

export const DiscountOnEnum = {
  COST_PRICE: 'COST_PRICE',
  SELLING_PRICE: 'SELLING_PRICE',
};

export const DiscountTypeEnum = {
  PERCENTAGE: 'PERCENTAGE',
  FLAT_AMOUNT: 'FLAT_AMOUNT',
};

export const SUBMIT_EP_PROGRAMME_FOR_REVIEW = gql`
  mutation SubmitEpProgrammeForReview(
    $dto: EnrichmentDraftItemCreateDTO!
    $isDraft: Boolean!
    $isReview: Boolean!
    $isPriceOnlyChanged: Boolean
  ) {
    submitEpProgrammeForReview(
      dto: $dto
      isDraft: $isDraft
      isReview: $isReview
      isPriceOnlyChanged: $isPriceOnlyChanged
    ) {
      ID
      fkDraft
      fkEnrichment
      fkEnrichmentSubsidy
      fkVendor
      fkSchool
      title
      cover
      accPacCode
      description
      type
      gst
      cda
    }
  }
`;

export const ENRICHMENT_VENDOR_ADMIN_REPORT_DOWNLOAD = gql`
  query downloadEnrichmentVendorAdminReport {
    enrichmentVendorAdminReport
  }
`;

export const ENRICHMENT_VENDOR_TRAINER_REPORT_DOWNLOAD = gql`
  query downloadEnrichmentVendorTrainerReport($forAllVendors: Boolean!) {
    enrichmentVendorTrainerReport(getAll: $forAllVendors)
  }
`;

export const APPROVE_ENRICHMENT_PROGRAMME_IN_REVIEW = gql`
  mutation ApproveEnrichmentProgrammeInReview($IDEnrichmentDraft: Int!) {
    approveEnrichmentProgrammeInReview(IDEnrichmentDraft: $IDEnrichmentDraft) {
      ID
      title
    }
  }
`;

export const REJECT_ENRICHMENT_PROGRAMME_IN_REVIEW = gql`
  mutation REJECT_ENRICHMENT_PROGRAMME_IN_REVIEW(
    $IDEnrichmentDraft: Int!
    $remark: String!
  ) {
    rejectEnrichmentProgrammeInReview(
      IDEnrichmentDraft: $IDEnrichmentDraft
      remark: $remark
    )
  }
`;

export const ENRICHMENT_DRAFT_ITEM_DETAILS = gql`
  query getAllDraftEnrichmentProgram(
    $vendorId: Int
    $filter: EnrichmentDraftFilter
    $pagination: Pagination
  ) {
    getAllDraftEnrichmentProgram(
      vendorID: $vendorId
      filter: $filter
      pagination: $pagination
    ) {
      totalCount
      data {
        ID
        label
        status
        fkUser
        enrichmentAttachmentDrafts {
          data {
            ID
            fkEnrichmentDraft
            fileKey
            fileURL
            fileName
            type
            mime
          }
        }
        enrichmentCentreDrafts {
          data {
            ID
            fkEnrichmentDraft
            fkCentre
            fkBillableItem
            centre {
              ID
              label
              code
            }
          }
        }
        enrichmentCostDrafts {
          data {
            ID
            fkEnrichmentDraft
            amount
            effectiveFrom
            effectiveTo
            enrichmentSubsidyCostDrafts {
              data {
                ID
                amount
                fkEnrichmentSubsidyTier
              }
            }
          }
        }
        enrichmentPriceDrafts {
          data {
            ID
            fkEnrichmentDraft
            amount
            effectiveFrom
            effectiveTo
            enrichmentSubsidyPriceDrafts {
              data {
                ID
                amount
                fkEnrichmentSubsidyTier
              }
            }
          }
        }
        enrichmentDraftItems {
          data {
            ID
            fkEnrichment
            fkEnrichmentSubsidy
            fkVendor
            title
            type
            cover
            coverURL
            description
            gst
            cda
            sessionDuration
            sessionPerWeek
            sessionPerMonth
            minClassSize
            maxClassSize
            accPacCode
            costCentre
            notify
            enrollType
            levelPrices
            levelCosts
            levelConfigs
            createdAt
            updatedAt
            levels {
              data {
                ID
                fkSchool
                label
                code
                promotionDate
                isInfant
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_ENRICHMENT_VENDOR_SOA = gql`
  query getEnrichmentVendorSoa(
    $q: String
    $from: Datetime
    $to: Datetime
    $filter: EnrichmentVendorSoaFilter
    $pagination: Pagination
  ) {
    getEnrichmentVendorSoa(
      q: $q
      from: $from
      to: $to
      filter: $filter
      pagination: $pagination
    ) {
      totalCount
      data {
        ID
        fkVendor
        soaDate
        description
        endingBalance
        pdfURLKey
        preSignedUrl
        active
        createdAt
        updatedAt
        vendor {
          ID
          code
          name
        }
      }
    }
  }
`;

export const GET_ENRICHMENT_CLASS_CHILD_PERFORMANCE = gql`
  query GetEnrichmentClassChildren(
    $searchChild: String!
    $classIDs: [Int!]
    $centreIDs: [Int!]
    $levelIDs: [Int!]
    $programIDs: [Int!]
    $statuses: [EnrichmentClassChildStatus!]
    $underApprovallist: Boolean
    $childFilter: EnrichmentClassChildFilter
    $pagination: Pagination
  ) {
    getEnrichmentClassChildren(
      searchChild: $searchChild
      classIDs: $classIDs
      centreIDs: $centreIDs
      levelIDs: $levelIDs
      programIDs: $programIDs
      statuses: $statuses
      underApprovallist: $underApprovallist
      childFilter: $childFilter
      pagination: $pagination
    ) {
      totalCount
      data {
        childID
        firstName
        lastName
        status
        centre
        level
        class
        programme
        enrichmentClassChild
      }
    }
  }
`;

export const APPROVE_CHILD_DOCUMENT_BY_ID = gql`
  mutation ApproveChildDocumentById($childDocumentId: Int) {
    approveChildDocumentById(childDocumentId: $childDocumentId)
  }
`;

export const REJECT_CHILD_DOCUMENT_BY_ID = gql`
  mutation RejectChildDocumentById(
    $childDocumentId: Int
    $rejectReason: String!
  ) {
    rejectChildDocumentById(
      childDocumentId: $childDocumentId
      rejectReason: $rejectReason
    )
  }
`;

export const GET_ENRICHMENT_CLASS_CHILD_DOCUMENT = gql`
  query GetEnrichmentClassChildDocument(
    $filter: EnrichmentClassChildDocumentFilter
    $from: Datetime
    $to: Datetime
    $pagination: Pagination
  ) {
    getEnrichmentClassChildDocument(
      filter: $filter
      from: $from
      to: $to
      pagination: $pagination
    ) {
      totalCount
      data {
        ID
        filePath
        fileSize
        documentType
        documentName
        reviewDate
        status
        remarks
        effectiveDate
        createdAt
        enrichmentClassChild {
          status
          effectiveFrom
          child {
            firstname
            lastname
          }
          currentClass {
            class {
              label
            }
          }
          enrichmentClass {
            name
            enrichment {
              title
            }
          }
          currentLevel {
            level {
              label
            }
            centre {
              label
            }
          }
        }

        userByUploadedBy {
          firstname
          lastname
        }

        userByApprovedBy {
          firstname
          lastname
        }
        preSignedUrl
      }
    }
  }
`;

export const GET_ENRICHMENT_CLASSES = gql`
  query GET_ENRICHMENT_CLASSES(
    $filter: EnrichmentClassFilter
    $pagination: Pagination
  ) {
    getEnrichmentClasses(filter: $filter, pagination: $pagination) {
      totalCount
      data {
        ID
        name
        centre {
          label
          code
        }
      }
    }
  }
`;

export const GetAllEnrichmentSubsidyTier = gql`
  query GetAllEnrichmentSubsidyTier(
    $filter: EnrichmentSubsidyTierFilter
    $pagination: Pagination
  ) {
    GetAllEnrichmentSubsidyTier(filter: $filter, pagination: $pagination) {
      totalCount
      data {
        ID
        label
        discountType
        discountValue
        effectiveFrom
        effectiveTo
      }
    }
  }
`;

export const GetAllEnrichmentSubsidy = gql`
  query GetAllEnrichmentSubsidy(
    $filter: EnrichmentSubsidyFilter
    $pagination: Pagination
  ) {
    GetAllEnrichmentSubsidy(filter: $filter, pagination: $pagination) {
      totalCount
      data {
        ID
        name
        effectiveFrom
        effectiveTo
        active
      }
    }
  }
`;

export const GET_ALL_GIRO_FILES = gql`
  query findAllEnrichmentDownloadedGiroFiles(
    $at: Datetime!
    $pagination: Pagination
  ) {
    findAllEnrichmentDownloadedGiroFiles(at: $at, pagination: $pagination) {
      totalCount
      data {
        exportFile {
          ID
          label
          uRL
          status
          giroStatus
          params
          log
          docType
          presignedUrl
          user {
            ID
            firstname
            lastname
          }
          createdAt
          uploadedAt
          fkFinanceDocument
        }
        returnFile {
          ID
          label
          uRL
          status
          giroStatus
          params
          log
          errorLog
          docType
          presignedUrl
          user {
            ID
            firstname
            lastname
          }
          createdAt
          uploadedAt
          fkFinanceDocument
        }
      }
    }
  }
`;

export const FIND_ENRICHMENT_SUBSIDY_TIERS = gql`
  query findEnrichmentSubsidyTiers($IDChild: Int!, $enrichmentClassID: Int!) {
    findEnrichmentSubsidyTiers(
      childID: $IDChild
      enrichmentClassID: $enrichmentClassID
    ) {
      data {
        ID
        label
        discountType
        discountValue
        gstTaxable
        effectiveFrom
        effectiveTo
        householdIncomeLabel
      }
    }
  }
`;

export const CANCEL_GIRO_REFUND_BY_DOCUMENT = gql`
  mutation cancelEnrichmentGiroDocument($IDSchool: Int!, $documentID: Int!) {
    cancelEnrichmentGiroDocument(IDSchool: $IDSchool, documentID: $documentID)
  }
`;

export const FETCH_ENRICHMENT_BILLING_PAYNOW_STATE = gql`
  query EnrichmentBillingPayNowState($IDChild: Int!) {
    enrichmentBillingPayNowState(IDChild: $IDChild) {
      payNowEffectiveEnabled
      showPayNowGiroWarning
      payNowGiroWarningMessage
    }
  }
`;
